import { useAuthContext } from 'src/auth/hooks/use-auth-context';

export function useMockedUser() {
  const { user } = useAuthContext();

  // const mockUser = {
  //   ...user,
  //   permissions: [Permission.BILLING],
  // };

  return { user };
}
